import React, { useRef, useState, useEffect } from "react";
import { FormikProvider, useFormik } from "formik";
import { Link } from "react-router-dom";
import { post } from "../../../helpers/api_helper";
import { POST_GetActiveInwardData } from "../../../helpers/url_helper";
import { Spin } from "antd";

const ActiveInward = () => {
  const [isLoading, setIsLoading] = useState(false);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [activeInwardList, setActiveInwardList] = useState([]);

  const formik = useFormik({
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      ActiveInwardType: 1,
      ActiveInwardList: [],
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: { ActiveInwardType, ActiveInwardList },
  } = formik;

  useEffect(() => {
    getActiveInwardDetails(1);
  }, []);

  const getActiveInwardDetails = async (typeid) => {
    formik.setFieldValue("ActiveInwardType", typeid);
    setIsLoading(true);

    let payload = {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      PeriodType: typeid,
    };

    await post(POST_GetActiveInwardData, payload)
      .then((response) => {
        formik.setFieldValue("ActiveInwardList", response?.List);
        // bindActiveInwardList(response?.List);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div>
        <Spin size="large" spinning={isLoading} tip={"Loading..."}>
          <div className="card mb-2" style={{ height: "calc(100% -10px)" }}>
            <div className="card-body p-1">
              <div className="table-responsive active-projects style-1 shorting">
                <div className="tbl-caption p-2">
                  <h4 className="heading mb-0">Active Inward</h4>
                  <FormikProvider value={formik}>
                    <form onSubmit={formik.handleSubmit}>
                      <div className="d-flex align-items-center">
                        <Link
                          title="Today Inward"
                          className={`btn ${
                            ActiveInwardType == 1
                              ? "btn-primary"
                              : "btn-outline-primary"
                          } btn-sm`}
                          onClick={(e) => {
                            getActiveInwardDetails(1);
                          }}
                        >
                          Today
                        </Link>
                        &nbsp;
                        <Link
                          title="This Week"
                          className={`btn ${
                            ActiveInwardType == 2
                              ? "btn-primary"
                              : "btn-outline-primary"
                          } btn-sm`}
                          onClick={(e) => {
                            getActiveInwardDetails(2);
                          }}
                        >
                          This Week
                        </Link>{" "}
                        &nbsp;
                        <Link
                          title="This Month"
                          className={`btn ${
                            ActiveInwardType == 3
                              ? "btn-primary"
                              : "btn-outline-primary"
                          } btn-sm`}
                          onClick={(e) => {
                            getActiveInwardDetails(3);
                          }}
                        >
                          This Month
                        </Link>{" "}
                        &nbsp;
                        <Link
                          title="Previous Month"
                          className={`btn ${
                            ActiveInwardType == 4
                              ? "btn-primary"
                              : "btn-outline-primary"
                          } btn-sm`}
                          onClick={(e) => {
                            getActiveInwardDetails(4);
                          }}
                        >
                          Previous Month
                        </Link>
                      </div>
                    </form>
                  </FormikProvider>
                </div>
                <div className="p-2 pt-0 pb-0">
                  <div
                    id="projects-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    <table
                      id="projects-tbl"
                      className="table dataTable no-footer mb-2"
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "20%" }}>Customer</th>
                          <th style={{ width: "20%" }}>Project </th>
                          <th style={{ width: "15%" }}>Inward No</th>
                          <th style={{ width: "10%" }}>No Of TC</th>
                          <th style={{ width: "10%" }}>No Of Test</th>
                          <th style={{ width: "10%" }}>Pending Test</th>
                          <th style={{ width: "15%", textAlign: "left" }}>
                            EDD
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {ActiveInwardList?.length > 0 ? (
                          ActiveInwardList?.map((item, indx) => (
                            <tr key={indx}>
                              <td>{item.CustomerName}</td>
                              <td>{item.ProjectName}</td>
                              <td>{item.InwardNo}</td>
                              <td>{item.NoOfTC}</td>
                              <td>{item.NoOfTest}</td>
                              <td>{item.PendingTest}</td>
                              <td style={{ textAlign: "left" }}>
                                {item.ExpectedDateOfDelivery}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={9} style={{ textAlign: "left" }}>
                              <div>{"No Record Found..."}</div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </div>
    </>
  );
};

export default ActiveInward;
